import { invokeFunction } from '@/api/adapters/supabase/shared'
import type { PromptCapture, PromptCaptureCursor, PromptCaptureList } from '@/api/prompt-capture-types'

export async function listPromptCaptures(cursor?: PromptCaptureCursor): Promise<PromptCaptureList> {
  return invokeFunction('admin-prompt-captures', { action: 'list', ...(cursor ? { cursor } : {}) })
}

export async function getPromptCapture(id: string): Promise<{ capture: PromptCapture }> {
  return invokeFunction('admin-prompt-captures', { action: 'get', capture_id: id })
}

export async function savePromptCapture(id: string): Promise<{ capture_id: string }> {
  return invokeFunction('admin-prompt-captures', { action: 'save', capture_id: id })
}

export async function deletePromptCapture(id: string): Promise<{ capture_id: string }> {
  return invokeFunction('admin-prompt-captures', { action: 'delete', capture_id: id })
}
